import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ErrorPrivate').create(({ theme }) => ({
  backdrop: {
    width: '100vw',
    minHeight: '120vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 99,
  },
  root: {
    backgroundColor: '#151516',
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    alignItems: 'center',
    // justifyContent: 'stretch',
    borderRadius: '12px',
    padding: '20px',
    gap: '12px',
    width: '90%',
    marginTop: '32px',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
    height: '100%',
  },

  title: {
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: theme.colors.text.primary,
    fontFamily: 'Inter',
    gap: '12px',

    h2: {
      margin: '0',
      fontWeight: '600',
      fontSize: theme.sizes.texts.fontSize.xl,

      lineHeight: '40px',
      fontStyle: 'normal',
      textTransform: 'none',
    },

    p: {
      margin: '0',
      fontWeight: '450',
      fontSize: theme.sizes.texts.fontSize.l,
      lineHeight: theme.sizes.texts.lineHeight.xl,

      fontStyle: 'normal',
      textTransform: 'none',
      color: theme.colors.text.secondary,
    },
  },

  textWlink: {
    width: '100%',
    color: theme.colors.text.secondary,
    fontFamily: 'Inter',
    fontWeight: '350',
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.m,

    textAlign: 'center',
    fontStyle: 'normal',
    p: {
      width: '100%',
      margin: '0',
    },

    a: {
      color: theme.colors.text.link,
      textDecoration: 'underline',
    },
  },

  settings: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  iconAndTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase',
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    color: theme.colors.text.secondary,
    gap: '6px',
  },

  largeSettingsContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    background: '#272729',
    border: '1px solid',
    borderColor: '#2B2B2C',
    borderRadius: '16px',
    justifyContent: 'space-between',
  },

  tinySettingsWrapper: {
    width: '100%',
    display: 'grid',
    gap: '8px',
    gridTemplateColumns: '0.5fr 0.5fr',
  },

  settingContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    background: '#272729',
    border: '1px solid',
    borderColor: '#2B2B2C',
    borderRadius: '16px',

    textTransform: 'uppercase',
    fontWeight: '370',
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    color: theme.colors.text.secondary,
    gap: '6px',
  },

  button: {},

  publicPrivate: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
    textUnderlineOffset: '2px',
  },

  buttonsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '85%',
    position: 'fixed',
    bottom: '12px',
  },

  private: {
    color: 'rgba(232, 53, 80, 1)',
    textTransform: 'uppercase',
    fontSize: theme.sizes.texts.fontSize.xs,
    fontWeight: '370',
    textDecoration: 'underline',
  },

  arrow: {
    fontSize: theme.sizes.texts.fontSize.xs,
    color: 'rgba(117, 119, 120, 1)',
    fontWeight: 370,
  },

  public: {
    color: theme.colors.text.primary,
    textTransform: 'uppercase',
    fontSize: theme.sizes.texts.fontSize.xs,
    textDecoration: 'underline',
  },

  refreshButton: {
    height: '52px',
    fontWeight: 460,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    color: theme.colors.text.primary,
  },

  willEnable: {
    margin: '0',
    fontWeight: '450',
    fontSize: theme.sizes.texts.fontSize.l,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    fontStyle: 'normal',
    textTransform: 'none',
    color: theme.colors.text.secondary,
  },

  tidWrapper: {
    position: 'absolute',
    right: 0,
    top: 0,
    padding: '8px 12px',
  },

  doubleConnectionRoot: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    background: 'black',
  },

  doubleConnectionBG: {
    width: '100%',
    height: '100%',
    maxHeight: '340px',
    maxWidth: '420px',
    zIndex: 4,
    filter: 'grayscale(100%) blur(6px)',
  },

  heading: {
    fontSize: theme.sizes.texts.fontSize.l,
    fontWeight: 450,
    lineHeight: theme.sizes.texts.lineHeight.xl,

    color: theme.colors.text.primary,
  },

  description: {
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.m,

    fontWeight: 350,
    color: theme.colors.text.secondary,
    textAlign: 'center',
  },

  headingAndSteamWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },

  descriptionWrapper: {},

  doubleConnectionContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    borderRadius: '12px',
    padding: '20px',
    width: '92.5%',
    height: '252px',
    position: 'absolute',
    bottom: '12px',
    zIndex: 5,
    backgroundColor: 'rgb(21, 21, 22)',
  },

  doubleConnectionButtonsWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  connectAnotherButton: {
    height: '52px',
    width: '100%',
    fontWeight: 460,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.xl,
  },

  continueWithoutButton: {
    height: '40px',
    fontWeight: 370,
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    width: '100%',
    boxShadow: 'none',
    textTransform: 'uppercase',
    background: 'transparent',
    color: theme.colors.text.secondary,
  },

  doubleConnectionBackdrop: {
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    zIndex: 3,
    backgroundColor: 'black',
  },
}))
